/**
 * Strip corrupted DB overrides that would wipe code defaults.
 * Example: contact.form saved as [] instead of { name, email, ... }.
 */

function sanitizeContactForm(contact) {
  if (!contact || typeof contact !== "object" || Array.isArray(contact)) return contact;
  if (!Array.isArray(contact.form)) return contact;
  const next = { ...contact };
  delete next.form;
  return next;
}

function sanitizeProcessSteps(process) {
  if (!process || typeof process !== "object" || Array.isArray(process)) return process;
  if (!Array.isArray(process.steps)) return process;
  return {
    ...process,
    steps: process.steps.filter((step) => step && typeof step === "object" && !Array.isArray(step)),
  };
}

function sanitizeLangSlice(langSlice) {
  if (!langSlice || typeof langSlice !== "object" || Array.isArray(langSlice)) return langSlice;
  let next = { ...langSlice };

  if (next.contact) {
    next = { ...next, contact: sanitizeContactForm(next.contact) };
  }
  if (next.process) {
    next = { ...next, process: sanitizeProcessSteps(next.process) };
  }

  return next;
}

/** @param {Record<string, unknown> | null | undefined} payload */
export function sanitizePayload(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return payload;
  }
  return {
    ...payload,
    ro: sanitizeLangSlice(payload.ro),
    en: sanitizeLangSlice(payload.en),
  };
}
